import type { ReactNode } from "react"
import { Navigate } from "react-router-dom"

import { useRbac } from "@/lib/auth"
import { puedeVer, seccionesDe } from "@/lib/secciones"
import type { Seccion } from "@/lib/secciones"

/**
 * Guarda de seccion.
 *
 * Esconder el enlace no alcanza: la URL se puede escribir. Esto redirige a la
 * primera seccion que el rol SI tiene, en vez de mostrar un 404 —que haria
 * pensar que la pantalla no existe cuando existe y no le corresponde—.
 *
 * Gatea por rol Y por ALCANCE. Solo con el rol, un contador acotado a una
 * sociedad aterrizaba en Auditoria y se llevaba tres 403 seguidos: el backend
 * exige alcance de tenant para el audit log, y eso el rol no lo dice.
 *
 * Sigue sin ser control de acceso: el control es el 403 del backend y RLS. Esto
 * evita que alguien aterrice en una pantalla que solo le va a devolver errores.
 */
export function RequireSeccion({
  seccion, children,
}: { seccion: Seccion; children: ReactNode }) {
  const { roles, tenantWide } = useRbac()
  const alcance = { tenantWide }

  // Sin ningun rol conocido no se gatea. No saber que rol tiene alguien no es
  // saber que no tiene ninguno: si el perfil llego sin alcances —o con roles que
  // esta version de la SPA no conoce—, redirigir lo dejaria dando vueltas al
  // dashboard sin explicacion. Se deja pasar y que responda el backend, que es
  // donde esta el control de verdad.
  if (roles.length === 0) return <>{children}</>

  if (puedeVer(seccion, roles, alcance)) return <>{children}</>

  const alternativa = seccionesDe(roles, alcance)[0]
  return <Navigate to={alternativa ? `/${alternativa}` : "/dashboard"} replace />
}
